const HAPPY_HOUR_WARNING_TIME_MINUTES = 20;

export { HAPPY_HOUR_WARNING_TIME_MINUTES };
